import { connection } from "./jsstore_con";

export class StudentService {

    constructor() {

        this.tableName = "Users";
    }

    getStudents() {
        return connection.select({
            from: this.tableName,
        })
    }

    getStudentCount() {
        return connection.count({
            from: this.tableName,
        })
    }

    getStudentsPaginated(skip, limit) {
        return connection.select({
            from: this.tableName,
            skip: skip,
            limit: limit,
        })
    }

    addStudent(student) {
        return connection.insert({
            into: this.tableName,
            values: [student],
            return: true
        })
    }

    getStudentById(id) {
        return connection.select({
            from: this.tableName,
            where: {
                id: id
            }
        })
    }

    removeStudent(id) {
        return connection.remove({
            from: this.tableName,
            where: {
                id: id
            }
        })
    }
    clearTable(){
   return  connection.clear('Users')
   .then(response=>{
     console.log(response);

   })


    }

    updateStudentById(student) {
        return connection.update({
            in: this.tableName,
            set: {
                firstname: student.firstname,
                lastname: student.lastname,
                middlename: student.middlename,
                email: student.email,
                nimc_number: student.nimc_number,
                phone_number: student.phone_number,
                dob: student.dob,
                expiry_date: student.expiry_date,
                gender: student.gender,
                genotype: student.genotype,
                address: student.address,
                blood: student.blood,
                marital_status: student.marital_status,
                sector: student.sector,
                sectorType: student.sectorType,
                category_of_vulnerable_group: student.category_of_vulnerable_group,
                provider_id: student.provider_id,
                localgovt: student.localgovt,
                ward: student.ward,
                place_of_work: student.place_of_work,
                salary_number: student.salary_number,
                org_id: student.org_id,
                user_image: student.user_image,
            },
            where: {
                id: student.id
            }
        })
    }
}
